import {cs} from "../../../../../../react/chain-services";
import {UseState} from "../../../../../../react/use-state";
import {last} from "../../../../../../utils/collections";
import {chain} from "../../../../../../utils/fs";

export const WizardControl = ({steps, next}) => cs(
    ["stepIndex", (_, next) => UseState({next})],
    ({stepIndex}) => {
        const avaiSteps = steps.map((step, index) => (!step.condition || step.condition()) && ({index})).filter(v=>v);
        const currentStepIndex = stepIndex.value != null && avaiSteps.find((s) => s.index === stepIndex.value) ? (
            stepIndex.value
        ) : (
            last(avaiSteps)?.index
        );
        if (currentStepIndex == null) {
            throw "Unable to determine wizard step";
        }

        return next({
            currentStep: {
                index: currentStepIndex,
                render: () => steps[currentStepIndex].render({
                    goBack: () => chain(
                        avaiSteps.findIndex((s) => s.index === currentStepIndex),
                        (_) => _ - 1,
                        (_) => stepIndex.onChange(avaiSteps[_].index),
                    ),
                    resetNav: () => stepIndex.onChange(null),
                }),
                name: steps[currentStepIndex].name,
            },
        });
    },
);
